import { memo } from 'react';

import { twMerge } from 'tailwind-merge';

import { Avatar, AvatarFallback, AvatarImage, Button, FormInput, Icon, Tooltip } from '@/_components';

import type { Props } from './use-preview';
import { usePreviewNumber } from './use-preview';

import { phoneTypeIcon } from '../../shared';
import { btnStyle, btnStyleDisabled } from '../../shared/style';
import { PhoneNumberControls } from '../controls';

function PreviewBase(props: Props) {
  const { country, type, number, onDelete, formattedNumber, handleOpen } = usePreviewNumber(props);

  return (
    <div className="flex flex-1 flex-nowrap items-start gap-1">
      <div className="mt-px flex pt-3">
        <Tooltip content={type.name}>
          <Button
            tag="div"
            title={type.name}
            as="outline"
            size="sm"
            disabled
            className={twMerge(btnStyle, btnStyleDisabled)}
          >
            <Avatar transparent size="sm" className="items-center justify-center border-0 text-center">
              {type ? <Icon icon={phoneTypeIcon(type.value)} /> : null}
            </Avatar>
          </Button>
        </Tooltip>
      </div>
      <div className="mt-px flex pt-3">
        <Tooltip content={`${country?.name}: ${country?.calling_code}`}>
          <Button
            tag="div"
            title={country?.name}
            as="outline"
            size="sm"
            disabled
            className={twMerge(btnStyle, btnStyleDisabled)}
          >
            <Avatar size="sm" legacyBgColor>
              <AvatarImage src={country?.flag?.url} />
              <AvatarFallback className="text-[0.625rem]" name={country?.name} />
            </Avatar>
          </Button>
        </Tooltip>
      </div>

      <div className="relative flex-1">
        <FormInput
          value={formattedNumber}
          disabled
          containerProps={{
            onClick: handleOpen,
            className: 'cursor-pointer group',
          }}
          forceHideMessage
          className="decoration-primary pl-1 decoration-2 disabled:pointer-events-none group-hover:disabled:underline"
        />
        <PhoneNumberControls onDelete={onDelete} number={number} />
      </div>
    </div>
  );
}

export const Preview = memo<Props>(PreviewBase);
